var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingNavibarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4870_7251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6901 13.625C12.416 13.625 13.8151 12.2259 13.8151 10.5C13.8151 8.77411 12.416 7.375 10.6901 7.375C8.96417 7.375 7.56506 8.77411 7.56506 10.5C7.56506 12.2259 8.96417 13.625 10.6901 13.625Z",
    stroke: "#6F6F6F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.92673 14.4132C3.5814 13.8184 3.31683 13.1803 3.14001 12.5156L4.45095 10.875C4.43611 10.6241 4.43611 10.3726 4.45095 10.1218L3.1408 8.4812C3.31731 7.81642 3.58134 7.17802 3.92595 6.58276L6.01267 6.34839C6.17931 6.16065 6.35696 5.98299 6.5447 5.81636L6.77908 3.73042C7.37348 3.38745 8.01083 3.12499 8.67439 2.94995L10.315 4.26089C10.5658 4.24605 10.8173 4.24605 11.0681 4.26089L12.7088 2.95073C13.3735 3.12725 14.0119 3.39127 14.6072 3.73589L14.8416 5.82261C15.0293 5.98924 15.207 6.1669 15.3736 6.35464L17.4595 6.58901C17.8049 7.18383 18.0694 7.82199 18.2463 8.48667L16.9353 10.1273C16.9502 10.3781 16.9502 10.6296 16.9353 10.8804L18.2455 12.521C18.0702 13.1856 17.8075 13.824 17.4642 14.4195L15.3775 14.6539C15.2109 14.8416 15.0332 15.0193 14.8455 15.1859L14.6111 17.2718C14.0163 17.6172 13.3781 17.8817 12.7135 18.0585L11.0728 16.7476C10.822 16.7625 10.5705 16.7625 10.3197 16.7476L8.67908 18.0578C8.01449 17.8825 7.3761 17.6198 6.78064 17.2765L6.54626 15.1898C6.35853 15.0232 6.18087 14.8455 6.01423 14.6578L3.92673 14.4132Z",
    stroke: "#6F6F6F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4870_7251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.690063 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingNavibarIcon);
export default __webpack_public_path__ + "static/media/SettingNavibarIcon.863a673f5e538369c29122c124325771.svg";
export { ForwardRef as ReactComponent };